import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

const anchors = document.querySelectorAll('a[href^="#"]');
const headerHeight = document.querySelector("header").offsetHeight;

// 画面幅の判定関数
const isPc = () => window.matchMedia("(min-width: 1024px)").matches;

anchors.forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    e.preventDefault();
    const href = anchor.getAttribute("href");
    if (!href || href === "#") {
      return; // 無効な href は無視
    }

    if (href === "#top") {
      // ページトップへのスクロール
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    } else {
      // ターゲット要素へのスクロール
      const target = document.getElementById(href.replace("#", ""));
      if (target) {
        let position = window.pageYOffset + target.getBoundingClientRect().top;

        // PCの場合のみヘッダーの高さを引く
        if (isPc()) {
          position -= headerHeight;
        }

        window.scroll({
          top: position,
          behavior: "smooth",
        });
      } else {
        console.error(`ターゲット要素が見つかりません: ${href}`);
      }
    }
  });
});

// ページ読み込み後にアンカー要素までスムーススクロール
window.addEventListener("load", () => {
  const hash = window.location.hash;
  if (hash) {
    const target = document.getElementById(hash.replace("#", ""));
    if (target) {
      const position =
        window.pageYOffset + target.getBoundingClientRect().top - headerHeight;
      window.scroll({
        top: position,
        behavior: "smooth",
      });
    } else {
      console.error(`ターゲット要素が見つかりません: ${hash}`);
    }
  }
});
